export default __webpack_public_path__ + "static/media/LOCATION.15366dc6.svg";